/**
 * 配置路由
 * @format
 */
import {createRouter, createWebHashHistory} from 'vue-router'

//跳转
import hello from "../components/main/hello";
//PC首页
import first from "../components/first/first";
//移动端首页
import mobileFirst from "../components/first/mobileFirst";
//PC端
import pcIndex from "../components/main/rouIndex";
//移动端
import mobileIndex from "../components/main/mobileIndex";
//文章列表引入
import essay from "../components/essay/essayList";
//移动端文章列表引入
import mobileEssay from "../components/essay/mobileEssayList";
//文章载体
import blog from "../components/essay/blogIndex";
//时间线引入
import line from "../components/timeLine/timeLine";
//友情链接
import ship from "../components/shipLink/shipList";
//移动端友情链接
import mobileShipList from "../components/shipLink/mobileShipList";
//跑步
import runner from "../components/runner/runList";
//移动端跑步
import mobileRunner from "../components/runner/mobileRunList";
//关于我
import about from "../components/about/aboutMeNew";
//关于我 单独路由引入 否则会加载不出来呃
import MobileAbout from "../components/about/aboutMe";
//网站收集
import joy from "../components/joy/joyList";
//跑步打卡
import check from "../components/check/checkList";
//跑步打卡录入
import insertCheck from "../components/check/insertDayData";

const routes = [
    {
        path: '/',
        name: 'hello',
        component: hello,
    },
    {
        path: '/pc',
        name: 'pcIndex',
        component: pcIndex,
        redirect: '/pc/first',
        children: [
            {
                path: '/pc/first',
                name: 'first',
                component: first,
            },
            {
                path: '/pc/essay',
                name: 'essay',
                component: essay,
            },
            {
                path: '/pc/line',
                name: 'line',
                component: line,
            },
            {
                path: '/pc/ship',
                name: 'ship',
                component: ship,
            },
            {
                path: '/pc/runner',
                name: 'runner',
                component: runner,
            },
            {
                path: '/pc/about',
                name: 'about',
                component: about,
            },
            {
                path: '/pc/blog',
                name: 'blog',
                component: blog,
            },
            {
                path: '/pc/joy',
                name: 'joy',
                component: joy,
            },
            {
                path: '/pc/check',
                name: 'check',
                component: check,
            },
            {
                path: '/pc/check/insert',
                name: 'insertCheck',
                component: insertCheck,
            },
        ]
    },
    {
        path: '/mobile',
        name: 'mobileIndex',
        component: mobileIndex,
        redirect: '/mobile/first',
        children: [
            {
                path: '/mobile/first',
                name: 'mobileFirst',
                component: mobileFirst,
            },
            {
                path: '/mobile/essay',
                name: 'mobileEssay',
                component: mobileEssay,
            },
            {
                path: '/mobile/blog',
                name: 'blogMobile',
                component: blog,
            },
            {
                path: '/mobile/runner',
                name: 'mobileRunner',
                component: mobileRunner,
            },
            {
                path: '/mobile/ship',
                name: 'mobileShip',
                component: mobileShipList,
            },
            {
                path: '/mobile/about',
                name: 'MobileAbout',
                component: MobileAbout,
            },
        ]
    },
]

const router = createRouter({
    history: createWebHashHistory(),
    routes,
})

export default router